import React, { useState } from "react";
import BetTable from "./BetTable";
import BetForm from "./BetForm";


const Bets = () => {
  const [showForm, setShowForm] = useState(false);
  
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold text-gray-900">Bets</h2>
      </div>

      {showForm && (
        <BetForm
        />
      )}
      <BetTable
      />
    </div>
  );
};
export default Bets;
